import Entity from './Entity';

import { stateFieldOptions } from './util';


const vehicleEntityFieldsWithStaticAllowedValues = {
  state: {
    options: stateFieldOptions
  }
};


export default class Vehicle {
  fields = {
    id: {
      value: null
    },
    make: {
      value: null
    },
    model: {
      value: null
    },
    license: {
      value: null
    },
    state: {
      value: null
    }
  };


  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      vehicleEntityFieldsWithStaticAllowedValues,
      {},
      fields
    );
  }


  static createFromQueryValues(values) {
    const vehicle = new this();

    for (let field in vehicle.fields) {
      if (values.hasOwnProperty(field)) {
        vehicle.fields[field].value = values[field];
      }
    }

    return vehicle;
  }


  getQueryFieldValues() {
    let values = {};

    for(let field in this.fields) {
      switch(field) {
        case 'id':
          if(this.fields[field].value && !this.fields[field].value.includes('temp')) {
            values[field] = this.fields[field].value;
          }
          break;
        default:
          if(this.fields[field].value !== null) {
            values[field] = this.fields[field].value;
          }
      }
    }

    return values;
  }
}
